<template>
  <div>
    <v-sheet width="1200" class="mt-16 pt-16" >

      <v-sheet class="pa-2 mx-auto overflow-auto noclick">
        <a href="https://www.revolvermaps.com/livestats/5mp4rx76mqz/"><img src="//rf.revolvermaps.com/h/m/a/0/ff0000/256/0/5mp4rx76mqz.png" width="1000" height="500" alt="Map" style="border:0;"></a>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "map"
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/map.vue